/** @jsx jsx */

import { useContext, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { getButtonFocus } from 'styles/variables';
import { Button } from '@chameleoncreator/creator-ui';
import { InteractionContext } from '../../Layouts/ContainerLogical';
import { useLayoutEffect } from 'react';
import getStore from 'services/getStore';
import isIE from 'services/isIE';
import { ModuleContext } from 'components/Module/Module_v2';
import { useSelector } from 'react-redux';

const store = getStore();
const ieCircleBtnPadding = 20;

const DButton = ({
  id,
  shape,
  background = 'pink',
  foreground = 'white',
  borderWidth,
  borderColor,
  borderRadius,
  buttonOutline,
  useLargeButton,
  buttonShadow,
  buttonHover,
  font = '',
  children,
  location,
  focusColor,
  enabled,
  ...props
}) => {
  const shapeStyle = {
    pill: 'border-radius: 9999px',
    rectangle: `border-radius: ${borderRadius}px`,
    circle: 'border-radius: 50%',
  }[shape];

  const ctx = useContext(InteractionContext) as any;
  const { exit: runExit } = useContext(ModuleContext);
  const btn = useRef<HTMLButtonElement>(null);
  // const exit = isLastInteraction(ctx.id);

  const exit = location === 'exit';

  const { fontFamily: fontFromTheme } = store.getState().theme;

  // the glitch found
  // using continue button in modals or anywhere outside of the ' root page '
  // they'll have this same locking behaviour
  let isLocked;

  if (window.dev()) {
    isLocked = false;
  } else {
    isLocked = ctx.isLocked === undefined ? false : ctx.isLocked;
    if (props.unlocked && props.unlocked === true) {
      isLocked = false;
    }
  }

  const _isLocked = useSelector((state: any) => {
    return state.blocks[ctx.id].props.lockDown;
  });

  if (_isLocked === 0) {
    isLocked = _isLocked;
  }

  useLayoutEffect(() => {
    if (!btn.current) {
      return;
    }

    if (shape === 'circle' && isIE()) {
      const size = btn.current.querySelector('#ie-btn-children-container')!
        .scrollWidth;
      btn.current.style.width = `${size + ieCircleBtnPadding}px`;
      btn.current.style.height = `${size + ieCircleBtnPadding}px`;
    }
  }, [btn.current]);

  useLayoutEffect(() => {
    if (!btn.current) {
      return;
    }

    if (shape === 'circle') {
      btn.current.style.height = `${btn.current.offsetWidth}px`;
      return;
    }
    btn.current.style.height = 'auto';
    btn.current.style.minHeight = '45px';

    if (isIE()) {
      const h = btn.current.querySelector('#ie-btn-children-container')!
        .scrollHeight;

      btn.current.style.height = `${h + 10}px`;
    }
  });

  // old vals
  // ${borderColor && `border: ${borderWidth}px solid ${borderColor};`}

  const disabled = !window.dev() ? !!isLocked : false;

  // console.log({
  //   disabled,
  //   isLocked,
  // });

  // boxShadow: getButtonFocus(focusColor || background).replace(
  //   'box-shadow',
  //   ''
  // ),

  // console.log(
  //   focusColor,
  //   background,
  //   // 'getButtonFocus :',
  //   getButtonFocus(focusColor || background)
  //     .replace('box-shadow', '')
  //     .split(':')[1]
  //     .trim()
  // );

  const buttonFocus = getButtonFocus(focusColor || background)
    .replace('box-shadow', '')
    ?.split(':')[1]
    ?.trim();

  // console.log(buttonFocus);

  return (
    <Button
      ref={btn}
      px={4}
      py={2}
      // bg={borderWidth === 0 ? background : 'transparent'}
      bg={buttonOutline ? 'transparent' : background}
      color={foreground}
      display={'flex'}
      disabled={disabled}
      css={css({
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        margin: !window.dev() ? '5px 10px' : 0,
        ...(shape !== 'circle' && {
          width: useLargeButton ? '308px' : '230px',
          minHeight: useLargeButton ? '64px !important' : '',
        }),
        wordBreak: shape === 'circle' ? 'normal' : 'break-word',
        lineHeight: 1.2,

        borderRadius: {
          pill: '9999px',
          rectangle: `${borderRadius}px`,
          circle: '50%',
        }[shape],
        cursor: 'pointer',
        outline: 'none',
        border: `1px solid ${background}`,
        fontFamily: `${font || fontFromTheme || 'inherit'} !important`,
        fontSize: '14px',

        ...((!font || !fontFromTheme) && {
          fontWeight: 400,
          fontStyle: 'normal',
        }),

        boxShadow: buttonShadow ? `0 0 12px 3px rgba(0, 0, 0, 0.09)` : 'none',

        '&:hover': {
          ...(buttonHover
            ? {
                background: buttonHover,
                border: `1px solid ${buttonHover}`,
              }
            : {
                opacity: 0.45,
              }),
        },

        '&:focus': {
          boxShadow: buttonFocus,
        },

        transition: 'all 0.2s',
      })}
      // css={css`
      //   position: relative;
      //   justify-content: center;
      //   align-items: center;
      //   ${shape !== 'circle' && `width: ${useLargeButton ? '308px' : '230px'};`}
      //   ${shape !== 'circle' &&
      //     useLargeButton &&
      //     'min-height: 64px !important;'}
      //   word-break: ${shape === 'circle' ? 'normal' : 'break-word'};
      //   line-height: 1.2;
      //   ${shapeStyle};
      //   cursor: pointer;
      //   outline: none;
      //   border: 1px solid ${background};
      //   font-family: ${font || fontFromTheme || 'inherit'} !important;
      //   font-size: 14px;
      //   ${(!font || !fontFromTheme) &&
      //     `
      //     font-weight: 400 !important;
      //     font-style: normal;
      //     `}
      //   ${buttonShadow && `box-shadow: 0 0 12px 3px rgba(0, 0, 0, 0.09);`}

      //   transition: background, border, color, opacity 0.2s;

      //   ${!window.dev() && 'margin: 5px 10px;'}

      //   &:hover {
      //     ${buttonHover ? `background: ${buttonHover}` : `opacity: 0.45`};
      // }
      //   }

      //   &:focus {
      //     ${getButtonFocus(focusColor || background)}
      //   }

      // `}

      data-as-exit-btn={exit && id}
      fontWeight="normal"
      onClick={e => {
        if (window.dev()) {
          return;
        }

        exit ? runExit() : ctx.next(location);
      }}
      style={{
        ...(isLocked && {
          opacity: 0.25,
          pointerEvents: 'none',
        }),
      }}
    >
      {isIE() ? (
        <div
          id="ie-btn-children-container"
          css={css`
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            left: 0;
            top: 50%;
            width: 100%;
            padding: 0 15px;
            ${shape === 'circle' &&
              `
              padding: ${ieCircleBtnPadding}px !important;
            `}
            transform: translateY(-50%);
          `}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </Button>
  );
};

export default DButton;
